import React from 'react';
import PropTypes from 'prop-types';
import { WizardStep } from '@zillow/zrs-rental-applications';
import { Button, Heading, IconFaceUnhappy, Paragraph } from '@zillow/constellation';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { getApplicationsTabPath } from '../../../constants/urls';
import useQueryVariables from '../../../hooks/useQueryVariables';

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const WithdrawnErrorStep = ({ id, label }) => {
  const { propertyId } = useQueryVariables();

  return (
    <WizardStep
      hidden
      id={id}
      label={label}
      meta={{ hideStepNavigation: true, hideOverviewLink: true }}
      data-test="error-step"
    >
      <IconFaceUnhappy fontColor="blue600" size="lg" />
      <Heading level={4} marginTop="sm" marginBottom="sm">
        {'Applicant(s) have withdrawn'}
      </Heading>
      <Paragraph marginBottom="md">
        {
          'It appears the applicant has already withdrawn their application and we are unable to decline it now. Access to all information on this applications has been removed but you can still send or receive new messages to the applicant, if needed.'
        }
      </Paragraph>
      <StyledLink to={getApplicationsTabPath(propertyId)} data-test="confirmation-step__link">
        <Button buttonType="primary">View all applications</Button>
      </StyledLink>
    </WizardStep>
  );
};

WithdrawnErrorStep.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default WithdrawnErrorStep;
